import "./contact.css";

import React from "react";

import { ANCHORS, CONTACT, CONTACT_DETAILS } from "../../data/content";
import { FacebookIcon, InstagramIcon } from "../general/Icons";
import PageMeta from "../general/PageMeta";
import { PageHero, Split, TitleBand } from "../general/PageSections";
import Faq from "./Faq";
import GroupBookingForm from "./GroupBookingForm";

const Contact = () => {
  return (
    <React.Fragment>
      <PageMeta
        title={CONTACT.TITLE}
        description={CONTACT.DESCRIPTION}
      />
      <PageHero
        src={"/images/contact/friends-garden.webp"}
        position={"50% 12%"}
        isBelowHeader
      />
      <TitleBand title={CONTACT.TITLE} />

      <Split image={{ src: "/images/contact/buffet-guests.webp", alt: "Guests enjoying a buffet in the garden", width: 1000, height: 1500 }}>
        <div className={"contact-details"}>
          <img
            src={"/images/logo.png"}
            alt={"Dikalo Highston"}
            width={371}
            height={198}
            className={"contact-logo"}
            loading={"lazy"}
          />
          <p className={"body-text"}>{CONTACT.INTRO}</p>
          <p className={"body-text"}>
            <a
              href={CONTACT_DETAILS.MAP_LINK}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              {CONTACT_DETAILS.ADDRESS}
            </a>
          </p>

          <div className={"contact-columns"}>
            <div>
              <h2 className={"contact-subtitle"}>Accommodation:</h2>
              <p className={"body-text"}>
                <a
                  href={CONTACT_DETAILS.WHATSAPP.link}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  {CONTACT_DETAILS.WHATSAPP.label}
                </a>
                <br />
                <a href={`mailto:${CONTACT_DETAILS.ACCOMMODATION_EMAIL}`}>{CONTACT_DETAILS.ACCOMMODATION_EMAIL}</a>
              </p>
            </div>
            <div>
              <h2 className={"contact-subtitle"}>Events:</h2>
              <p className={"body-text"}>
                <a href={CONTACT_DETAILS.EVENTS_PHONE.link}>{CONTACT_DETAILS.EVENTS_PHONE.label}</a>
                <br />
                <a href={`mailto:${CONTACT_DETAILS.EVENTS_EMAIL}`}>{CONTACT_DETAILS.EVENTS_EMAIL}</a>
              </p>
            </div>
          </div>

          <ul className={"contact-socials"}>
            <li>
              <a
                href={CONTACT_DETAILS.FACEBOOK_LINK}
                target={"_blank"}
                rel={"noopener noreferrer"}
                aria-label={"Dikalo Highston on Facebook"}
              >
                <FacebookIcon />
              </a>
            </li>
            <li>
              <a
                href={CONTACT_DETAILS.INSTAGRAM_LINK}
                target={"_blank"}
                rel={"noopener noreferrer"}
                aria-label={"Dikalo Highston on Instagram"}
              >
                <InstagramIcon />
              </a>
            </li>
          </ul>
        </div>
      </Split>

      <section
        id={ANCHORS.GROUP_BOOKING}
        className={"group-booking"}
        aria-labelledby={"group-booking-title"}
      >
        <h2
          id={"group-booking-title"}
          className={"group-title"}
        >
          {CONTACT.GROUP_TITLE}
        </h2>
        <GroupBookingForm />
      </section>

      <div className={"contact-map"}>
        <iframe
          title={"Map showing Dikalo Highston, 9 Highland Avenue, Bryanston"}
          src={CONTACT_DETAILS.MAP_EMBED}
          loading={"lazy"}
          referrerPolicy={"no-referrer-when-downgrade"}
        />
      </div>

      <Faq />
    </React.Fragment>
  );
};

export default Contact;
